export const getDocumentName = ([, docId], id)=>{
    return `rl-doc-${docId}-${id}-v28`;
};
